import { addDays, addMonths } from 'date-fns';
import { formatDate } from 'src/utils/formatDate';

export function formatBillingStartDate(
  freeTrialLengthDays: number,
  locale?: string
) {
  return formatDate(
    freeTrialLengthDays ? addDays(new Date(), freeTrialLengthDays) : '',
    { locale }
  );
}

export function formatBillingStartDateAfterMonths(
  months: number,
  locale?: string
) {
  return formatDate(addMonths(new Date(), months), { locale });
}
